import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TextField,
  NumberField,
  Paragraph,
  Dropdown,
  DateTime,
  Checkbox,
  Toggle,
  RadioButton,
  Link,
  StakeholderDropdown,
} from "./CustomizedControls";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteBookingFile,
  getActivityAssignmentIdByBookingId,
  getValueByBookingTemplateId,
  updateBooking,
  uploadBookingFile,
} from "../../redux/actions/booking";
import { getAllBookingByCompanyId, getAllBookingName, getAllCustomFieldsByBookingTemplateId } from "../../redux/actions/bookingtemplate";
import { getCollaboratorByType } from "../../redux/actions/user";
import { Customer } from "../../constant/AuthenticationConstant";
import Select, {components} from "react-select";
import Loader from "./Loader";
import { allowUploadExtension, sanitizeInput } from "../../utils";
import { getStakeholderComponents } from "../../redux/actions/manageComponent";
import Dropzone from "react-dropzone";
import { isUUIDv4 } from "../../utils";
import { getConfigurationData } from "../../redux/actions/configurationAction";
import { GET_ALL_BOOKING_NAME } from "../../redux/constants";

function UpdateBooking() {
  const [component, setComponent] = useState([]);
  const [customFieldMaxRowSize, setCustomFieldMaxRowSize] = useState();
  const [newjson, setNewJson] = useState([]);
  const [assignmentid, setAssignmentId] = useState("");
  const [updatedjson, setUpdatedJson] = useState([]);
  const [validateobj, setValidateObj] = useState([]);
  const [bookingtemplateid, setBookingTemplateId] = useState("");
  const [validation, setValidation] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { activity_assignment_id } = state;
  const dispatch = useDispatch();
  const [allcustomers, setAllCustomers] = useState([]);
  const [customer, setCustomer] = useState();
  const [customerId, setCustomerId] = useState("");
  const { collaboratorList } = useSelector((state) => state.user);
  const { bookingValue } = useSelector((state) => state.booking);
  const [uploadedfile, setUploadedFile] = useState([]);
  const [loaderOpen, setLoaderOpen] = useState(false);

  // new states
  const [bookingDetails, setBookingDetails] = useState(null);
  const [tab, setTab] = useState(1);
  const [allbookingtemp, setAllBookingTemp] = useState([]); 
  const [booking, setBooking] = useState("");
  const [bookingtempid, setBookingTempId] = useState(null);
  const [allconfigs, setAllConfigs] = useState([]);
  const [workflow, setWorkflow] = useState("");
  const [configid, setConfigId] = useState(null);
  const [stakeholderjson, setStakeholderjson] = useState([]);

  const { configurationData } = useSelector((state) => state.configurationReducer);
  const { stakeholderComponents } = useSelector(state => state.manageComponent);

  useEffect(() => {
    if (bookingValue) {
      setUploadedFile(bookingValue?.file_uploads);
    }
  }, [bookingValue]);

  useEffect(() => {
    if (
      component.length > 0 &&
      newjson.length > 0 &&
      component.length !== newjson.length
    ) {
      var arr = [];
      component.map((ele) => {
        const type = ele.component.type;
        arr.push({
          booking_template_custom_field_id:
            ele.booking_template_custom_field_id,
          value:
            type === "toggle" || type === "check box"
              ? JSON.stringify(ele.component.is_check_by_default)
              : null,
          type: type,
          booking_template_custom_field: ele,
          booking_id: activity_assignment_id,
        });
      });
      if (newjson.length > 0) {
        for (let i = 0; i < newjson.length; i++) {
          for (let j = 0; j < arr.length; j++) {
            if (
              newjson[i].booking_template_custom_field?.component_id ==
              arr[j].booking_template_custom_field?.component_id
            ) {
              arr[j].value = newjson[i].value;
              arr[j].booking_control_id = newjson[i].booking_control_id;
            }
          }
        }
      }
      setUpdatedJson(arr);
    } else {
      setUpdatedJson(newjson);
    }
  }, [component, newjson]);

  useEffect(() => {
    dispatch(
      getActivityAssignmentIdByBookingId(activity_assignment_id, (res) => {
        if (res.status === 1 && res.data) {
          setBookingDetails(res.data)
          setAssignmentId(res.data?.activity_assignment_id);
          setBookingTemplateId(res.data?.booking_template_id);
          setCustomerId(res.data?.customer_id);
          if (res.data?.customer) {
            setCustomer({
              label: res.data?.customer.name,
              value: res.data?.customer.customer_id,
            });
          }
        }
      })
    );
    setNewJson([]);
    dispatch(
      getValueByBookingTemplateId(activity_assignment_id, (res) => {
        if (res.status === 1) {
          setNewJson(res.data.controls);
        }
      })
    );
    dispatch(getCollaboratorByType(Customer));
    dispatch(getStakeholderComponents({onSuccess: () => {}, onError: (res) => {}}));
    dispatch(
      getAllBookingByCompanyId((res) => {
        if (res.status === 1) {
          const result = res.data;
          const arr = [];
          result.data.map((item) => {
            arr.push({
              value: item.booking_template_name,
              label: item.booking_template_name,
              id: item.booking_template_id,
            });
          });
          setAllBookingTemp(arr);
        }
      })
    );
    dispatch(getConfigurationData({error: () => {}}));
  }, []);

  useEffect(() => {
    if (collaboratorList?.data?.length > 0) {
      const arr = [];
      collaboratorList?.data?.map((item) => {
        arr.push({
          value: item.collaborator_id,
          label: item.name,
        });
      });
      setAllCustomers(arr);
    }
  }, [collaboratorList]);

  const getCustomerId = (e) => {
    setCustomer(e);
  };

  useEffect(() => {
    if (bookingtemplateid !== "") {
      dispatch(
        getAllCustomFieldsByBookingTemplateId(bookingtemplateid, (res) => {
          if (res.status === 1) {
            const seq = res.data.sort(function (a, b) {
              return a.sequence - b.sequence;
            });
            setComponent(seq);
          }
        })
      );
    }
  }, [bookingtemplateid]);

  useEffect(() => {
    if(bookingDetails && Object.keys(bookingDetails).length > 0){
      if(bookingDetails?.booking_template){
        setBooking(bookingDetails?.booking_template);
        setBookingTempId(bookingDetails?.booking_template_id)
      };
      if(bookingDetails?.configuration){
        setWorkflow(bookingDetails?.configuration);
        setConfigId(bookingDetails?.configuration_id)
      };
      if(bookingDetails?.booking_stakeholders){
        const data = bookingDetails.booking_stakeholders.map(item => (
          {
            stakeholder_category_id: item.stakeholder_category_id,
            collaborator_id: item.collaborator_id,
            is_email: false
          }
        ))
        setStakeholderjson(data)
      }
    }
  }, [bookingDetails])

  const sortingFunction = (a, b) => {
    return (
      a.booking_template_custom_field.sequence -
      b.booking_template_custom_field.sequence
    );
  };

  const UpdateBooking = () => {
    const errorArray = updatedjson
      .sort(sortingFunction)
      .map((component, index) => {
        return component.booking_template_custom_field.is_required &&
          !component.value
          ? component.booking_template_custom_field_id
          : null;
      });

    setValidation(errorArray);
    if (errorArray.some((element) => typeof element === "string")) return;

    dispatch(
      updateBooking(updatedjson, assignmentid, customerId, customer, configid, bookingtempid, stakeholderjson, (res) => {
        if (res.status === 1) {
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content="Booking has been updated successfully."
                onClick={() => {
                  if (uploadedfile.length > 0) {
                    let formdata = new FormData();
                    for (const item of uploadedfile) {
                      formdata.append("file", item);
                    }
                    dispatch(
                      uploadBookingFile(
                        activity_assignment_id,
                        formdata,
                        (res) => {}
                      )
                    );
                  }
                  navigate(`/assignment/assign/${assignmentid}`);
                }}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      })
    );
  };
    

  const handleChange = (e, id, type) => {
    if (type === "dropdown") {
      var value = e === null ? null : e.value;
    } else if (type === "checkbox") {
      var value = JSON.stringify(e.target.checked);
    } else {
      var value = type === "datetime" ? e[0] : sanitizeInput(e.target.value);
    }
    updatedjson.map((ele, index) => {
      if (ele.booking_template_custom_field_id === id) {
        let copyjson = [...updatedjson];
        copyjson[index].value = value;
        setUpdatedJson(copyjson);
      }
    });
  };

  const renderInput = (input, index, validation) => {
    var value;
    updatedjson.forEach((ele) => {
      if (
        ele.booking_template_custom_field_id ===
        input.booking_template_custom_field_id
      ) {
        value = ele.value;
      }
    });
    const isMandatory = input.is_required;

    const gridPosition = JSON.parse(input.grid_position);
    const inputWidth = gridPosition?.w ? gridPosition.w : 2;
    const gridWidthClass = `${
      parseInt(inputWidth) !== 4 ? (parseInt(inputWidth) / 4) * 100 : 100
    }`;

    const props = {
      isMandatory,
      validation,
      value,
      input,
      index,
      handleChange: handleChange,
      gridWidthClass,
    };
    if (input.component?.type === "text") {
      return <TextField {...props} />;
    } else if (input.component?.type === "toggle") {
      return <Toggle {...props} />;
    } else if (input.component?.type === "radio group") {
      return <RadioButton {...props} />;
    } else if (input.component?.type === "link") {
      return <Link {...props} />;
    } else if (input.component?.type === "check box") {
      return <Checkbox {...props} />;
    } else if (input.component?.type === "dropdown") {
      return <Dropdown {...props} />;
    } else if (input.component?.type === "date/time") {
      return <DateTime {...props} />;
    } else if (input.component?.type === "paragraph") {
      return <Paragraph {...props} />;
    } else if (input.component?.type === "number") {
      return <NumberField {...props} />;
    } else {
      return null;
    }
  };

  const renderStakeholderInput = (input) => {
    var value;
    stakeholderjson.forEach((item) => {
      if(input.default_component_sub_type === item.stakeholder_category_id){
        value = item.collaborator_id
      }
    })
    
    const gridPosition = JSON.parse(input.grid_position || '{}');
    const inputWidth = gridPosition?.w ? gridPosition.w : 1;
    const gridWidthClass = `${
      parseInt(inputWidth) !== 4 ? (parseInt(inputWidth) / 4) * 100 : 100
    }`;
    const props = {
      input,
      value,
      handleChange: (e) => {
        const stakeholderIndex = stakeholderjson.findIndex(item => item.stakeholder_category_id === e.stakeholder_category_id);
        let is_email = false;
        if(!isUUIDv4(e.value)) is_email = true;
        let payload = {
          stakeholder_category_id: e.stakeholder_category_id,
          is_email: is_email
        }
        if(stakeholderIndex === -1){
          stakeholderjson.push({
            ...payload,
            collaborator_id: e.value
          })
          
        }else{
          stakeholderjson[stakeholderIndex] = {
            ...payload,
            collaborator_id: e.value
          }
        }
      },
      gridWidthClass,
    };
    return <StakeholderDropdown {...props} />
  };

  const uploadFile = (e) => {
    setLoaderOpen(true);
    for (const item of e) {
      let fileName = "";
      var filetype = item.name.split(".").pop();
      fileName = item.name;
      const type = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpeg",
        "jpg",
        "png",
        "bmp",
        "txt",
      ];
      const maxFileSize = 4 * 1024 * 1024;
      if (item.size > maxFileSize) {
        setLoaderOpen(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} file exceeds upload limit of 4 MB.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      if (!type.includes(filetype.toLowerCase())) {
        setLoaderOpen(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} must be among these pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, txt.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
    }
    setUploadedFile((prev) => {
      return [...prev, ...e];
    });
    setLoaderOpen(false);
  };

  useEffect(() => {
    if (component.length > 0) {
      const lastCustomField = JSON.parse(
        component[component.length - 1].grid_position
      );
      const highestRow = lastCustomField.y;
      setCustomFieldMaxRowSize(highestRow);
    }
  }, [component]);

  useEffect(() => {
    if (configurationData?.data?.length !== 0) {
      const arr = [];
      configurationData?.data?.map((item) => {
        arr.push({
          value: item.configuration_id,
          label: item.configuration_name,
        });
      });
      setAllConfigs(arr);
    }
  }, [configurationData]);

  const getBookingCustomFields = (e) => {
    setBooking(e);
    const id = e === null ? null : e.id;
    if (id !== "" && id !== null) {
      setBookingTempId(id);
      dispatch(getAllBookingName(id, (res) => {
        if(res.status) setComponent(res.data);
      }));
    } else {
      dispatch({
        type: GET_ALL_BOOKING_NAME,
        payload: [],
      });
      setBookingTempId(null);
      setComponent([])
    }
  };

  const getConfigId = (e) => {
    setWorkflow(e);
    const id = e === null ? null : e.value;
    setConfigId(id);
  };

  return (
    <div class="block w-full sm:block min-h-100">

      <div className="flex items-end space-x-4">
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12 grow w-full"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left flex items-center space-x-2">
            <div
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 1 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(1)}
            >
              Booking Details
            </div>
          </li>
          {/* <li className="text-left flex items-center space-x-2">
          ${
                state || assignmentFormik.values.inventory_order_id
                  ? "cursor-pointer"
                  : "pointer-events-none"
              }
            <div
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2
                
              cursor-pointer ${
                tab === 2 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(2)}
            >
              Workflows
            </div>
          </li> */}
        </ul>
        <div className="flex justify-end items-center space-x-4">
          <button
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              navigate("/booking/overview");
            }}
          >
            Cancel
          </button>
          <button
            className="btn !bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white cursor-pointer w-48"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              UpdateBooking();
            }}
          >
            Update Booking
          </button>
        </div>
      </div>

      {
        tab === 1 && (
          <>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                // UpdateBooking();
              }}
              className="flex-auto pt-4 pb-10 space-y-4"
            >

              <div className="p-3 border border-slate-200 rounded-md bg-[--bg-color-50]">
                <p className="font-inter font-bold text-[15px] text-[#535860]">Basic Details</p>
                <div className="w-full pt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
                  <div className="transition-all">
                    <label for="assets" className="mb-2 font-inter font-medium text-sm text-[#535860]">
                      Internal Booking ID
                      {/* <span className="text-rose-500">*</span> */}
                    </label>
                    <input
                      type="text"
                      name="referencenum"
                      id="reference-num"
                      className={`form-input w-full !bg-slate-100`}
                      placeholder="Enter Internal Reference Number"
                      value={bookingDetails?.job_id}
                      disabled
                    />
                  </div>
                  <div className="transition-all">
                    <label for="customer" className="mb-2 font-inter font-medium text-sm text-[#535860]">
                      Customer
                    </label>
                    <Select
                      className="basic-single text-sm unresetText"
                      classNames={{
                        option: (style) => {
                          return `${
                            style.isSelected && "!bg-[--bg-color-500] !text-white"
                          } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
                        },
                        control: (style) => {
                          return `!border !shadow-sm ${
                            style.isFocused
                              ? "!border-[--bg-color-300]"
                              : "!border-slate-200 hover:!border-gray-300"
                          }}`;
                        },
                        container: (style) => {
                          return "!h-[37.5px] !font-inter !text-sm";
                        },
                        menuList: (style) => {
                          return `!max-h-[200px]`;
                        },
                      }}
                      isClearable={true}
                      classNamePrefix="select"
                      name="customername"
                      options={allcustomers}
                      value={customer}
                      placeholder="Select Customer"
                      onChange={(e) => getCustomerId(e)}
                      // components={
                      //   type === Super_Admin ? { MenuList: CustomMenuList } : {}
                      // }
                    />
                  </div>
                  <div className="transition-all">
                    <label for="assets" className="mb-2 font-inter font-medium text-sm text-[#535860]">
                      Booking Template<span className="text-rose-500">*</span>
                    </label>
                    <Select
                      className="basic-single text-sm unresetText"
                      classNames={{
                        option: (style) => {
                          return `${
                            style.isSelected && "!bg-[--bg-color-500] !text-white"
                          } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
                        },
                        control: (style) => {
                          return `!border !shadow-sm ${
                            style.isFocused
                              ? "!border-[--bg-color-300]/50"
                              : "!border-slate-200 hover:!border-gray-300"
                          }`;
                        },
                        container: (style) => {
                          return "!h-[37.5px] !font-inter !text-sm";
                        },
                        menuList: (style) => {
                          return `!max-h-[200px]`;
                        },
                      }}
                      isClearable={true}
                      classNamePrefix="select"
                      name="bookingtemp"
                      options={allbookingtemp}
                      value={booking}
                      placeholder="Select Booking Template"
                      onChange={(e) => getBookingCustomFields(e)}
                      required
                    />
                  </div>
                  <div className="transition-all">
                    <label for="assets" className="mb-2 font-inter font-medium text-sm text-[#535860]">
                      Workflow
                    </label>
                    <Select
                      className="basic-single text-sm unresetText"
                      classNames={{
                        option: (style) => {
                          return `${
                            style.isSelected && "!bg-[--bg-color-500] !text-white"
                          } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
                        },
                        control: (style) => {
                          return `!border !shadow-sm ${
                            style.isFocused
                              ? "!border-[--bg-color-300]/50"
                              : "!border-slate-200 hover:!border-gray-300"
                          }`;
                        },
                        container: (style) => {
                          return "!h-[37.5px] !font-inter !text-sm";
                        },
                        menuList: (style) => {
                          return `!max-h-[200px]`;
                        },
                      }}
                      isClearable={true}
                      classNamePrefix="select"
                      name="configname"
                      options={allconfigs}
                      value={workflow}
                      placeholder="Select Workflow"
                      onChange={(e) => getConfigId(e)}
                      // onChange={handleInput}
                      isDisabled={bookingDetails?.assignment_count > 0}
                    />
                  </div>
                </div>
              </div>            
              {customFieldMaxRowSize?.toString() && component.length > 0 && (
                <div className="p-3 border border-slate-200 rounded-md bg-[--bg-color-50]">
                  <p className="pb-2 font-inter font-bold text-[15px] text-[#535860]">Booking Template</p>
                  {component.map((customeComponent, index) => {
                    const filteredComponentList = component.filter(
                      (element) => JSON.parse(element.grid_position).y === index
                    );

                    if (index <= customFieldMaxRowSize) {
                      return (
                        <div className="flex flex-wrap">
                          {filteredComponentList.map((comp, indexNumber) => {
                            return renderInput(comp, comp.booking_template_custom_field_id, validation);
                          })}
                        </div>
                      );
                    }
                  })}
                </div>
              )}

              {/* Stakeholder Section */}
              {stakeholderComponents?.length > 0 && (
                <div className="p-3 border border-slate-200 rounded-md bg-[--bg-color-50]">
                  <p className="pb-2 font-inter font-bold text-[15px] text-[#535860]">Stakeholders</p>
                    <div className="flex flex-wrap">
                      {stakeholderComponents.map((comp, indexNumber) => {
                        return renderStakeholderInput(
                          comp
                        );
                      })}
                    </div>
                </div>
              )}

              {/* Assets & Quantities */}
              
              <div className="w-full grid grid-cols-12 gap-2">
                <div className="xxs:col-span-8 lg:col-span-9 p-3 border border-slate-200 rounded-md bg-[--bg-color-50]">
                  <p className="pb-2 font-inter font-bold text-[15px] text-[#535860]">Assets & Quantities</p>                  
                  {bookingDetails?.booking_assets?.map((item, i) => (
                    <div key={i} className="w-full p-1.5 mb-1 flex flex-row items-center justify-between border border-slate-200 rounded-md bg-[--bg-color-100]">
                      <div className="w-full flex flex-row items-center">
                        <p className="font-inter font-semibold text-[13px] text-[#535860]">{item.quantity?.trim()}x</p>
                        <p className="pl-4 font-inter font-semibold text-[13px] text-[--bg-color-500] whitespace-nowrap">{item.asset_type}</p>
                        <p className="pr-1 pl-8 font-inter font-normal italic text-[13px] text-[#535860] truncate">{item.remarks}</p>
                      </div>
                    </div>
                  ))}    
                </div>
                <div className="xxs:col-span-4 lg:col-span-3 p-3 border border-slate-200 rounded-md bg-[--bg-color-50]">
                  <div className="w-full">
                    <p className="pb-2 font-inter font-bold text-[15px] text-[#535860]">Documents</p>
                    <div>
                      <Dropzone
                        accept={allowUploadExtension.join(",")}
                        onDrop={(acceptedFiles) => {
                          uploadFile(acceptedFiles)
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          // bg-slate-200
                          <section className="rounded-xl border-2 border-dashed border-[#94A3B8] h-[140px] flex justify-center items-center ">
                            <div {...getRootProps()}>
                              <input {...getInputProps()} />
                              <div className="space-y-2">
                                <>
                                  <span class="fa-light fa-arrow-up-from-bracket text-2xl font-normal block text-center"></span>
                                  <h4 className="text-sm text-[#94A3B8] font-medium">
                                    Drop your files here or
                                  </h4>
                                  <div className="flex justify-center">
                                    <button className="btn !h-8 !border !border-[--bg-color-500] text-[--bg-color-500] flex justify-center">
                                      Browse Files
                                    </button>
                                  </div>
                                </>
                              </div>
                            </div>
                          </section>
                        )}
                      </Dropzone>
                      <div className="mt-4 space-y-1">
                        {uploadedfile.length > 0 && uploadedfile.map((item, index) => (
                          <div className="flex flex-row justify-between items-center py-1">
                            <div className="w-[80%] truncate font-inter font-bold text-[13px] text-[#535860]">
                              {item.file_name ? item.file_name : item?.name}
                            </div>
                            <div
                              title="Delete"
                              className={`fa-regular fa-trash-can text-lg text-rose-500 cursor-pointer`}
                              onClick={(e) => {
                                if (isUUIDv4(item.booking_file_upload_id)) {
                                  setLoaderOpen(true);
                                  dispatch(
                                    deleteBookingFile(item.booking_file_upload_id, (res) => {
                                      setLoaderOpen(false);
                                      dispatch(
                                        getValueByBookingTemplateId(
                                          activity_assignment_id,
                                          (resp) => {
                                            swal({
                                              content: (
                                                <CustomeModal
                                                  type="success"
                                                  title="Success!"
                                                  content={`Uploaded file deleted successfully`}
                                                />
                                              ),
                                              buttons: false,
                                              closeOnClickOutside: false,
                                              closeOnEsc: false,
                                            });
                                          }
                                        )
                                      );
                                    })
                                  );
                                } else {
                                  setUploadedFile(
                                    uploadedfile.filter(
                                      (ele, i) => i !== parseInt(index)
                                    )
                                  );
                                }
                              }}
                            ></div>
                          </div>                                    
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <Loader modalOpen={loaderOpen} />
          </>
        )
      }


      
    </div>
  );
}

export default UpdateBooking;